import type { Location } from "history";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

/**
 * Hook that reads queryState from the URL using the provided hydrate function.
 *
 * Parses URL search params into a QueryState structure.
 *
 * @param hydrateQueryState - Function to convert Location to QueryState
 * @returns QueryState object containing filters, sort, and pagination
 */
export function useQueryStateFromUrl<T>(
  hydrateQueryState: (location: Location) => T,
): T {
  const location = useLocation();
  // Intentionally omit `location` and `hydrateQueryState` from deps to avoid infinite loops from object reference changes
  // eslint-disable-next-line
  return useMemo(() => hydrateQueryState(location), [location.search]);
}
